export {default} from './EmbedConfirmationPromiseModal'
